import { randomNmber } from "./base";
import MD5 from "./MD5";
import HmacSHA256 from "./HmacSHA256";
import Base64 from "./Base64";
import { getEncodeText } from "./RSA/index.js";

const encodePass = (pass: string): string => {
	return Base64.encode(getEncodeText(pass));
};
export { randomNmber, MD5, HmacSHA256, encodePass };
